import { USER_FRAGMENT } from 'features/user/api/fragments/user'
import { Ability } from 'providers/casl'
import { ERROR_FRAGMENT } from 'providers/tanstack-query/errors'
import { TypedDocumentNode } from 'providers/tanstack-query/types'
import { gql } from 'providers/tanstack-query/utils'
import { Data, Variables } from './types'

export const CONFIRM_USER = (
  ability: Ability,
): TypedDocumentNode<Data, { input: Variables }> => gql`
  ${USER_FRAGMENT(ability)}
  ${ERROR_FRAGMENT}

  mutation confirmUser($input: ConfirmUserInput!) {
    confirmUser(input: $input) {
      accessToken
      refreshToken

      user {
        ...UserFragment
      }

      errors {
        ...ErrorFragment
      }
    }
  }
`
